import { openBlock as e, createElementBlock as a, createStaticVNode as t } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, c = /* @__PURE__ */ t('<g clip-path="url(#a)"><path fill-rule="evenodd" d="M4.552.763A1.75 1.75 0 0 1 5.789.25h4.422c.464 0 .909.184 1.237.513l3.79 3.789c.328.328.512.773.512 1.237v4.422c0 .464-.184.909-.513 1.237l-3.789 3.79a1.75 1.75 0 0 1-1.237.512H5.789a1.75 1.75 0 0 1-1.237-.513l-3.79-3.789a1.75 1.75 0 0 1-.512-1.237V5.789c0-.464.184-.909.513-1.237L4.552.762Zm1.237.987a.25.25 0 0 0-.177.073l-3.789 3.79a.25.25 0 0 0-.073.176v4.422c0 .066.026.13.073.177l3.79 3.789a.25.25 0 0 0 .176.073h4.422a.25.25 0 0 0 .177-.073l3.789-3.79a.25.25 0 0 0 .073-.176V5.789a.25.25 0 0 0-.073-.177l-3.79-3.789a.25.25 0 0 0-.176-.073H5.789Z" clip-rule="evenodd"></path><path fill-rule="evenodd" d="M8 3.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V4A.75.75 0 0 1 8 3.25Z" clip-rule="evenodd"></path><path d="M9 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"></path></g><defs><clipPath id="a"><path d="M0 0h16v16H0z"></path></clipPath></defs>', 2), d = [
  c
];
function o(p, h) {
  return e(), a("svg", l, [...d]);
}
const n = { render: o };
export {
  n as default,
  o as render
};
